package cc.bluepeak.clubmanager.site.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.silk.components.forms.InputStyle
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.focusWithin
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

val UnderlinedInputVariant = InputStyle.addVariant {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.borderBottom(1.px, LineStyle.Solid, palette.secondary)
    }
    hover {
        Modifier.borderBottom(1.px, LineStyle.Solid, palette.primary)
    }
    focusVisible {
        Modifier.borderBottom(1.px, LineStyle.Solid, palette.primary)
    }
    focus {
        Modifier.borderBottom(1.px, LineStyle.Solid, palette.primary)
    }
    focusWithin {
        Modifier.borderBottom(1.px, LineStyle.Solid, palette.primary)
    }
}